<template>
  <div class="pagina-step">
    <span class="pagina-step-title">{{ cidadeEstado }}</span>
    <div class="container-form">
      <ValidationObserver ref="observer" class="row">
        <div class="col-md-12 col-lg-12 col-12">
          <div class="d-flex">
            <span class="span-label"
              >Qual era o valor mensal da capitação ponderada?</span
            >
            <!-- <span
              v-b-tooltip.hover
              title="Texto explicativo"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span> -->
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <div>
              <!-- <input
                type="text"
                v-model="form.capitacaoPonderada"
                name="capitacaoPonderada"
                class="form-control"
                v-inputmask="maskMoney"
                required
              /> -->
              <money
                v-model="form.capitacaoPonderada"
                v-bind="money"
                name="capitacaoPonderada"
                class="form-control"
                disabled
              ></money>
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-12 col-lg-12 col-12">
          <div class="d-flex">
            <span class="span-label"
              >Qual era o valor mensal do pagamento por desempenho?</span
            >
            <!-- <span
              v-b-tooltip.hover
              title="Texto explicativo"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span> -->
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <div>
              <!-- <input
                type="text"
                v-model="form.pagamentoDesempenho"
                name="pagamentoDesempenho"
                class="form-control"
                v-inputmask="maskMoney"
                required
              /> -->
              <money
                v-model="form.pagamentoDesempenho"
                v-bind="money"
                name="pagamentoDesempenho"
                class="form-control"
                disabled
              ></money>
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-12 col-lg-12 col-12">
          <div class="d-flex">
            <span class="span-label"
              >Informar o valor mensal do Informatiza APS</span
            >
            <!-- <span
              v-b-tooltip.hover
              title="Texto explicativo"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span> -->
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <div>
              <!-- <input
                type="text"
                v-model="form.informatizaAps"
                name="informatizaAps"
                class="form-control"
                v-inputmask="maskMoney"
                required
              /> -->
              <money
                v-model="form.informatizaAps"
                v-bind="money"
                name="informatizaAps"
                class="form-control"
                disabled
              ></money>
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-12 col-lg-12 col-12">
          <div class="d-flex">
            <span class="span-label">
              Informar o valor mensal pelos indicadores da Saúde Bucal</span
            >
            <!-- <span
              v-b-tooltip.hover
              title="Texto explicativo"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span> -->
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <div>
              <!-- <input
                type="text"
                v-model="form.indicadoresSaudeBucal"
                name="indicadoresSaudeBucal"
                class="form-control"
                v-inputmask="maskMoney"
                required
              /> -->
              <money
                v-model="form.indicadoresSaudeBucal"
                v-bind="money"
                name="indicadoresSaudeBucal"
                class="form-control"
                disabled
              ></money>
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-12 col-lg-12 col-12">
          <div class="d-flex">
            <span class="span-label">
              Informar o valor mensal do Saúde na Hora</span
            >
            <!-- <span
              v-b-tooltip.hover
              title="Texto explicativo"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span> -->
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <div>
              <!-- <input
                type="text"
                v-model="form.indicadoresSaudeNaHora"
                name="indicadoresSaudeNaHora"
                class="form-control"
                v-inputmask="maskMoney"
                required
              /> -->
              <money
                v-model="form.indicadoresSaudeNaHora"
                v-bind="money"
                name="indicadoresSaudeNaHora"
                class="form-control"
                disabled
              ></money>
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-md-12 col-lg-12 col-12">
          <div class="d-flex">
            <span class="span-label"
              >Informar o valor mensal do pagamento com base em critério
              populacional</span
            >
            <!-- <span
              v-b-tooltip.hover
              title="Texto explicativo"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span> -->
          </div>
          <validation-provider v-slot="{ errors }" rules="required">
            <div>
              <!-- <input
                type="text"
                v-model="form.pagamentoCriterioPopulacional"
                name="pagamentoCriterioPopulacional"
                class="form-control"
                v-inputmask="maskMoney"
                required
              /> -->
              <money
                v-model="form.pagamentoCriterioPopulacional"
                v-bind="money"
                name="pagamentoCriterioPopulacional"
                class="form-control"
                disabled
              ></money>
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
      </ValidationObserver>
    </div>
    <div class="container-buttons">
      <button type="button" @click="voltar">Voltar</button>
      <button @click="proximo">Avançar</button>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { TheMask } from 'vue-the-mask'
import Masks from '@/mixins/masks'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import { Money } from 'v-money'

export default {
  components: {
    PulseLoader,
    'vue-select': VueSelect,
    ValidationObserver,
    ValidationProvider,
    TheMask,
    Money,
  },
  props: {
    dados: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      form: {
        capitacaoPonderada: '',
        pagamentoDesempenho: '',
        informatizaAps: '',
        indicadoresSaudeBucal: '',
        indicadoresSaudeNaHora: '',
        pagamentoCriterioPopulacional: '',
      },
      loadingBtn: false,
    }
  },
  mounted() {
    if (this.dados?.etapa6 !== null) {
      const etapa6 = this.dados?.etapa6
      this.form.capitacaoPonderada = etapa6.capitacaoPonderada
      this.form.pagamentoDesempenho = etapa6.pagamentoDesempenho
      this.form.informatizaAps = etapa6.informatizaAps
      this.form.indicadoresSaudeBucal = etapa6.indicadoresSaudeBucal
      this.form.indicadoresSaudeNaHora = etapa6.indicadoresSaudeNaHora
      this.form.pagamentoCriterioPopulacional =
        etapa6.pagamentoCriterioPopulacional
    }
  },
  computed: {
    cidadeEstado() {
      return `Sobre o Previne Brasil de ${this.dados?.etapa1.cidade.no_municipio} - ${this.dados?.etapa1.estado.uf}`
    },
    maskMoney() {
      return Masks['money']
    },
  },
  methods: {
    salvarDados() {
      this.$emit('dados-etapa', { etapa: 'etapa6', dados: this.form })
    },
    voltar() {
      this.$emit('etapa-anterior')
    },
    proximo() {
      this.$refs.observer.validate().then(async (success) => {
        if (success) {
          try {
            this.loadingBtn = true
            this.salvarDados()
            this.$emit('proxima-etapa')
          } catch (error) {
            console.log(error)
          } finally {
            this.loadingBtn = false
          }
        } else {
          this.$toast.warning('Preencha os campos obrigatórios!', 'Erro:', {
            position: 'topRight',
          })
        }
      })
    },
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />
<style>
.Etapa6 {
  height: auto !important;
}
</style>
